import apiClient from "./apiClient";

export const createMyOrganization = async (name) => {
  const response = await apiClient.post("/onboarding/organization", { name });
  return response.data;
};

export const updateMyOrganization = async (name) => {
  const response = await apiClient.patch("/onboarding/organization", { name });
  return response.data;
};

export const completeTenantWelcome = async () => {
  const response = await apiClient.post("/onboarding/tenant-welcome/complete");
  return response.data;
};

export const previewInvite = async (token) => {
  const response = await apiClient.get("/onboarding/invitations/preview", {
    params: { token },
  });
  return response.data;
};

export const acceptInvite = async (body) => {
  const response = await apiClient.post("/onboarding/invitations/accept", body);
  return response.data;
};

export const sendInvite = async ({ email, role_id, tenant_id }) => {
  const config = {};
  if (tenant_id != null) config.params = { tenant_id };
  const response = await apiClient.post(
    "/onboarding/invitations",
    { email, role_id },
    config
  );
  return response.data;
};

/**
 * @param {{
 *   tenant_id?: number,
 *   status?: 'pending'|'expired'|'accepted'|'revoked'|'all',
 *   skip?: number,
 *   limit?: number
 * }} params — tenant_id required for platform admins
 */
export const listInvites = async (params = {}) => {
  const axiosParams = {};
  if (params.tenant_id != null) axiosParams.tenant_id = params.tenant_id;
  if (params.status != null) axiosParams.status = params.status;
  if (params.skip != null) axiosParams.skip = params.skip;
  if (params.limit != null) axiosParams.limit = params.limit;
  const response = await apiClient.get("/onboarding/invitations", {
    params: axiosParams,
  });
  return response.data;
};

/** @param {{ tenant_id?: number }} params — required for platform admins */
export const listPendingInvites = async (params = {}) =>
  listInvites({ ...params, status: "pending" });

export const resendInvite = async (invitationId, { tenant_id } = {}) => {
  const config = {};
  if (tenant_id != null) config.params = { tenant_id };
  const response = await apiClient.post(
    `/onboarding/invitations/${invitationId}/resend`,
    {},
    config
  );
  return response.data;
};

export const revokeInvite = async (invitationId, { tenant_id } = {}) => {
  const config = {};
  if (tenant_id != null) config.params = { tenant_id };
  await apiClient.delete(`/onboarding/invitations/${invitationId}`, config);
};
